import { render, staticRenderFns } from "./cellWidth-editor.vue?vue&type=template&id=8ddfb426&scoped=true&"
import script from "./cellWidth-editor.vue?vue&type=script&lang=js&"
export * from "./cellWidth-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddfb426",
  null
  
)

export default component.exports